import { type AuthUser } from 'aws-amplify/auth';

import { UserGroupOrEntitlement } from '@/models/User.ts';

import { useAuthStore } from '@/stores/authStore.ts';

interface AuthUserHook {
    auth_user: AuthUser | undefined;
    is_admin: boolean;
    email: string;
    groups: string[];
    scopes: string[];
    customer_ids: string[];
    instance_ids: string[];
    location_ids: string[];
    picture_url: string | undefined;
    isUserInGroup: (groups_to_check: UserGroupOrEntitlement | UserGroupOrEntitlement[]) => boolean;
}

const useAuth = (): AuthUserHook => {
    const {
        user: auth_user,
        is_admin,
        user_email: email,
        user_scopes: scopes,
        user_groups: groups,
        user_instance_ids: instance_ids,
        user_customer_ids: customer_ids,
        user_location_ids: location_ids,
        picture_url,
    } = useAuthStore((state) => state);

    const isUserInGroup = (groups_to_check: UserGroupOrEntitlement | UserGroupOrEntitlement[]): boolean => {
        if (is_admin) return true;

        const groupsArray: UserGroupOrEntitlement[] = Array.isArray(groups_to_check)
            ? groups_to_check
            : [groups_to_check];
        const userGroupsSet = new Set(groups);

        return groupsArray.some((group) => userGroupsSet.has(group));
    };

    return {
        auth_user,
        is_admin,
        email,
        scopes,
        groups,
        instance_ids,
        customer_ids,
        location_ids,
        picture_url,
        isUserInGroup,
    };
};

export default useAuth;
